import React from 'react';

function Layout(props) {
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
}
export default Layout;